import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { AxiosPromise, AxiosRequestConfig } from 'axios';

import { api } from '@/api';

export async function getTicketJobs(
  params: openapi.GetTicketJobs_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetTicketJobs_200> {
  return await api.get<openapi.GetTicketJobs_200>('/ticket/jobs/', {
    ...requestConfig,
    params,
  });
}

export async function postTicketNotificationsMarkAllAsRead(
  params: openapi.PostTicketNotificationsMarkAllRead_Query,
  data: openapi.PostTicketNotificationsMarkAllRead_Body,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.PostTicketNotificationsMarkAllRead_200> {
  return await api.post<openapi.PostTicketNotificationsMarkAllRead_200>(
    '/ticket/notifications/mark_all_as_read/',
    data,
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getTicketDashboardUnread(
  params: openapi.GetTicketDashboardUnread_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetTicketDashboardUnread_200> {
  return await api.get<openapi.GetTicketDashboardUnread_200>(
    '/ticket/dashboard/unread/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getTicketDashboardAll(
  params: openapi.GetTicketDashboardAll_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetTicketDashboardAll_200> {
  return await api.get<openapi.GetTicketDashboardAll_200>(
    '/ticket/dashboard/all/',
    {
      ...requestConfig,
      params,
    },
  );
}

export async function getTicketDashboardUnreadCount(
  params: openapi.GetTicketDashboardUnreadCount_Query,
  requestConfig: AxiosRequestConfig = {},
): AxiosPromise<openapi.GetTicketDashboardUnreadCount_200> {
  return await api.get<openapi.GetTicketDashboardUnreadCount_200>(
    '/ticket/dashboard/unread_count/',
    {
      ...requestConfig,
      params,
    },
  );
}
